<template>
	
	<div class="vpay__splash-screen">
		
		<div class="vpay__splash-screen-inner">
			<div v-loading="true"></div>
		</div>
		
	</div>
	
</template>

<script>
	
	export default {
		
		name: "VPaySplashScreen",
		
		data() {
			return {};
		}
		
	}
	
</script>

<style>
	
	.vpay__splash-screen {
		width: 100%;
		min-height: 400px;
		height: 400px;
	}
	
	.vpay__splash-screen-inner {
		display: table;
		width: 100%;
		height: 100%;
	}
	
	.vpay__splash-screen-inner div {
		display: table-cell;
		vertical-align: middle;
	}
	
</style>
